import { ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function CtaFinalPlataforma() {
  return <section data-section-id="REEMPLAZAR" id="cta-final-plataforma" className="bg-background text-foreground py-16 md:py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.08)_0%,transparent_60%)] pointer-events-none" />
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto rounded-2xl bg-card border-2 border-primary/30 p-8 md:p-12 lg:p-16 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <ShieldCheck className="size-4 text-primary" />
            <span className="text-xs font-mono uppercase tracking-wider text-primary">
              Pruébala con tu operación real
            </span>
          </div>
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Conoce la plataforma <span className="text-primary font-mono">por dentro</span>
          </h2>
          <p className="mt-6 max-w-2xl mx-auto text-lg text-slate-400 font-default leading-relaxed">
            14 días de Pro completo, con todos los módulos activos, para que pruebes Notalia con tus propios clientes. Sin tarjeta, sin contrato.
          </p>
          <div className="mt-10 flex flex-col items-center gap-3">
            <a href="https://panel.notalia.app/register" target="_blank" rel="noopener noreferrer">
              <Button size="lg" className="px-10 h-14 text-lg font-semibold bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-200">
                Empieza gratis
                <ArrowRight className="ml-2 size-5" />
              </Button>
            </a>
            <p className="text-xs text-muted-foreground font-mono">
              Sin tarjeta · Sin contrato · Cancela cuando quieras
            </p>
          </div>
        </div>
      </div>
    </section>;
}